/**
 * Signaling room code: 5 digits generated by the server
 * (`apps/signaling`, alphabet `0-9`, single use, TTL ≤ 10 min). Here lives the
 * normalization/validation shared by the UI and the tests (the user may
 * type it with spaces or dashes when copying it from another device).
 */

export const ROOM_CODE_LENGTH = 5;

/** Leaves only digits (tolerates spaces, dashes and keyboard remnants). */
export function normalizeRoomCode(raw: string): string {
  return raw.replaceAll(/\D/g, "");
}

export function isCompleteRoomCode(raw: string): boolean {
  return normalizeRoomCode(raw).length === ROOM_CODE_LENGTH;
}
